import {IPlatformApiProvider} from '@shared/services/platform-api-provider';
import {Api} from '@shared/constants/common-field.constants';

export class FieldSchemaApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/field-schema')) {
      return Api.Projects;
    }
    return '';
  }
}
